import React, { useEffect, useState, useMemo } from 'react';
import Downloads from '../../components/Downloads';
import moment from 'moment';
import './style.scss';

interface QuickAnalyticsModuleProps {
  content: object;
  firehoseAnalytics: Function;
  reportActivity: Function;
  getData: Function;
  selectOptions: unknown;
  currentUser: object;
}

const QuickAnalyticsModule: React.FC<QuickAnalyticsModuleProps> = ({
  content,
  getData,
  firehoseAnalytics,
  reportActivity,
  selectOptions,
  currentUser,
}) => {
  const [startDate, setStartDate] = useState(updateDateState('7').startDate);
  const [endDate, setEndDate] = useState(updateDateState('7').endDate);
  const [analytics, setAnalytics] = useState({});
  const dateObject = {
    startDate: startDate,
    endDate: endDate,
  };

  // We're not allowed to see it
  if (!App.INSTANCE.CurrentUser.isContentEditor(content)) {
    return <></>;
  }

  const routeToEditContent = () => {
    let url = App.INSTANCE.appRouter.generate('navigate.editcontent', {
      slug: content.Slug,
      tab: 'basic',
    });
    App.INSTANCE.route(url);
  };

  const dataUrl = 'custom_api/api_analytics_getBasic.php';

  function updateDateState(dateString) {
    const days = parseInt(dateString);
    const start = moment().utc();
    const end = moment().utc();

    return {
      startDate: start.subtract(days, 'day').format('YYYY-MM-DD HH:mm:ss'),
      endDate: end.format('YYYY-MM-DD HH:mm:ss'),
    };
  }

  useEffect(() => {
    // @ts-ignore
    getData(dataUrl, content.Id, startDate, endDate, data => {
      setAnalytics(data.stats);
    });
  }, [startDate]);

  return (
    <>
      <div className="quick_analytics">
        <div
          className="juno_edit_config_button"
          onClick={() => {
            routeToEditContent();
          }}
        >
          <div className="edit_config_image">
            <i className={`${FontAwesomeConfigurations.ICON_GEAR}`} />
          </div>
          <div className={`config_button_text_container`}>{CrowdHub_App.LANG.EDIT_CONTENT_EDIT}</div>
        </div>
        <div className="analytics_header primary-font-family">{CrowdHub_App.LANG.ANALYTICS_HEADER}</div>
        <div className="left_container">
          <div className="only_users date_label">{CrowdHub_App.LANG.ANALYTICSONLYADMINS}</div>
        </div>
        <div className="left_container">
          <div className="date_label">{CrowdHub_App.LANG.ANALYTICSFOR}</div>
          <div className="date_dropdown">
            <select
              name="start_date"
              id="start_date"
              className="input"
              onChange={e => {
                let dates = updateDateState(e.target.value);
                setStartDate(dates.startDate);
                setEndDate(dates.endDate);
              }}
            >
              {selectOptions.map(option => {
                return (
                  <option value={option.value} key={option.value}>
                    {option.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div className="right_container">
          <div className="date_label">{CrowdHub_App.LANG.ANALYTICSRESULT}</div>
          <div className="number_container">
            <div className="stat total_views">{analytics?.total_views}</div>
            <div className="stat_label">Total Views</div>
          </div>
          <div className="number_container">
            <div className="stat total_views">{analytics?.unique_views}</div>
            <div className="stat_label">Unique Views</div>
          </div>
          <div className="number_container">
            <div className="stat total_views">{analytics?.unique_users}</div>
            <div className="stat_label">Unique Users</div>
          </div>
          <div className="number_container">
            <div className="stat total_views">{analytics?.downloads}</div>
            <div className="stat_label">Total Downloads</div>
          </div>
          <div className="number_container">
            <div className="stat total_views">{analytics?.contact_clicks}</div>
            <div className="stat_label">Total Clicks</div>
          </div>
        </div>
        <div className="download_container">
          <div className="date_label">{CrowdHub_App.LANG.DOWNLOAD_HEADER}</div>
          <div className="download_buttons_container">
            {
              <Downloads
                currentUser={currentUser}
                content={content}
                dateObject={dateObject}
                firehoseAnalytics={firehoseAnalytics}
                reportActivity={reportActivity}
              ></Downloads>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default QuickAnalyticsModule;
